import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getPlans } from "@/Services/TherapyApi/Clients";
import InfoFilterTransformer from "@/Modules/Transformers/Patients/InfoFilter";

import usePatientsStore from "../Store";
import useAppStore from "@/Modules/App/Store";

async function fetchPlansAH(): Promise<boolean> {
  const patientsStore = usePatientsStore();
  const appStore = useAppStore();

  patientsStore.isLoading = true;

  try {
    const plans = await getPlans();

    patientsStore.plans = plans.map(InfoFilterTransformer.toDomain);

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    patientsStore.isLoading = false;
  }
}

export default fetchPlansAH;
